
import en from '../../locales/en.json';
import hi from '../../locales/hi.json';
const initialstate = {
     'language': en
}

const settingReducer = (state = initialstate,action) =>{
     switch(action.type) {
         case 'en':
               return {...state,language:en};
         case 'hi':
            return {...state,language:hi};
         default:
            return state;   
     }
}

export default settingReducer;

